module.exports = __webpack_public_path__ + "static/media/ImageSlider001.7a599354.jpeg";